import { Component, OnInit, Input, ChangeDetectionStrategy, Pipe, PipeTransform } from '@angular/core';
import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
import { environment } from 'environments/environment';
//import { TeaserDetailDialogService } from '../../_modules/dialog/teaser-detail-dialog/teaser-detail-dialog.service';

@Component({
  selector: 'div.teaserDetail',
  templateUrl: './teaser-detail.component.html',
  styleUrls: ['./teaser-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeaserDetailComponent implements OnInit {
  isAdult = environment.cinema === 2;
  @Input() video;
  @Input() responsiveTeaserSize;
  @Input() fromList = false;

  @Input()
  hasWatched = false;

  @Input()
  hovered = false;

 // @Input() newStyle = true;

  constructor(
    //private teaserDetailService: TeaserDetailDialogService,
    private _dnDialogService: DnDialogService,
  ) { }

  ngOnInit(): void {
   // console.debug("teaser-detail init")
  }

  // cidMapperArray(cidMapper) {
  //   return !!cidMapper ? cidMapper.split(',') : [];
  // }

  // replaceComma(r) {
  //   if (r !== null && r !== undefined) {
  //     return r.replace(/,/g, ' / ');
  //   }
  //   return '';
  // }

  openTeaserDialog($event: any, video) {
    $event.preventDefault();
    $event.stopPropagation();
    //this.teaserDetailService.setState(video);
    // setTimeout(()=> {
    // }, 50);
    //console.log(video.key)
    this._dnDialogService.open('teaser-detail-dialog',video);

  }

}


